import { render, staticRenderFns } from "./BlogListingItem.vue?vue&type=template&id=1256e63d&scoped=true&"
import script from "./BlogListingItem.vue?vue&type=script&lang=js&"
export * from "./BlogListingItem.vue?vue&type=script&lang=js&"
import style0 from "./BlogListingItem.vue?vue&type=style&index=0&id=1256e63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256e63d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1256e63d')) {
      api.createRecord('1256e63d', component.options)
    } else {
      api.reload('1256e63d', component.options)
    }
    module.hot.accept("./BlogListingItem.vue?vue&type=template&id=1256e63d&scoped=true&", function () {
      api.rerender('1256e63d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/BlogListingItem.vue"
export default component.exports